import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";

const ContactPage = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("contact");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(true);
  }, []);

  const contactInfo = [
    {
      country: "Portugal",
      flag: "🇵🇹",
      organization: "Metaphora Theater – Friends of the Arts Association",
      address: "Portugal",
      email: "tmetaphora@gmail.com",
    },
    {
      country: "Romania",
      flag: "🇷🇴",
      organization: "A.R.T. Fusion Association",
      address: "Romania",
      email: "office@artfusion.ro",
    },
    {
      country: "Tunisia",
      flag: "🇹🇳",
      organization: "The Euro-Mediterranean Exchange Association",
      address: "Tunisia",
      email: "Info@euromedeve.com",
    },
    {
      country: "Morocco",
      flag: "🇲🇦",
      organization: "Morocco's Friends Foundation",
      address: "Morocco",
      email: "mffmorocco@gmail.com",
    },
    {
      country: "Poland",
      flag: "🇵🇱",
      organization:
        'Association in the Aid of Children and Youth "We add Wings"',
      address: "Poland",
      email: "uskrzydlamyngo@gmail.com",
    },
    {
      country: "Jordan",
      flag: "🇯🇴",
      organization: "Jordan Youth Innovation Forum",
      address: "Jordan",
      email: "office@jyif.org",
    },
    {
      country: "Egypt",
      flag: "🇪🇬",
      organization: "Have-A-Dream",
      address: "Egypt",
      email: "Info@have-adream.com",
    },
  ];

  const handleEmailClick = (email) => {
    window.location.href = `mailto:${email}?subject=Inquiry about DCA Project&body=Hello,%0D%0A%0D%0AI am interested in learning more about the DCA project.%0D%0A%0D%0APlease provide me with more information.%0D%0A%0D%0AThank you!`;
  };

  return (
    <div className=" min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50">
      {/* Header */}
      <Header
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      {/* Partners Section */}
      <section className=" py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-white via-emerald-50/30 to-teal-50/30"></div>

        <div className="mt-12 relative max-w-7xl mx-auto px-4 md:px-8">
          <div
            className={`transition-all duration-1000 flex flex-col items-center justify-center  ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            <div className="inline-flex items-center px-6 py-3 rounded-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-sm font-semibold mb-8">
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              Contact Our Partners
            </div>

            <h1 className="text-6xl md:text-7xl font-bold mb-8">
              <span className="bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 bg-clip-text text-transparent">
                Get In Touch
              </span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto text-center leading-relaxed mb-12">
              Connect with our project partners across Europe. We're here to
              answer your questions and collaborate on meaningful change.
            </p>
          </div>

          {/* Contact Cards Grid */}
          <div
            className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 delay-300 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            {contactInfo.map((contact, index) => (
              <div
                key={index}
                className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100 overflow-hidden"
              >
                {/* Background Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/50 to-teal-50/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                {/* Content */}
                <div className="relative z-10 flex flex-col h-full">
                  {/* Header */}
                  <div className="flex items-center mb-6">
                    <div className="text-5xl mr-4 group-hover:scale-110 transition-transform duration-300">
                      {contact.flag}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-emerald-700 transition-colors duration-300">
                        {contact.organization}
                      </h3>
                      <p className="text-sm text-gray-500 font-medium">
                        {contact.country}
                      </p>
                    </div>
                  </div>

                  {/* Location */}
                  <div className="flex items-center mb-6">
                    <div className="w-10 h-10 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-xl flex items-center justify-center mr-3">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </div>
                    <p className="text-gray-600 font-medium">
                      {contact.address}
                    </p>
                  </div>

                  {/* Email Button - Push to bottom */}
                  <div className="mt-auto">
                    <button
                      onClick={() => handleEmailClick(contact.email)}
                      className="group/btn inline-flex items-center w-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-6 py-4 rounded-xl font-semibold hover:from-emerald-600 hover:to-teal-600 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
                    >
                      <svg
                        className="w-5 h-5 mr-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                      <span className="flex-1 text-left">{contact.email}</span>
                      <svg
                        className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform duration-300"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                {/* Hover Border */}
                <div className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-gradient-to-r group-hover:from-emerald-500 group-hover:to-teal-500 group-hover:opacity-20 transition-all duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
    </div>
  );
};

export default ContactPage;
